// extracted by mini-css-extract-plugin
module.exports = {"detail":"tower-detail_detail_3-8_w","listWrap":"tower-detail_listWrap_3CEB3"};